export default __webpack_public_path__ + "static/media/Excellent Amrita.c12a81b9.jpg";